import { Button, DialogContent, DialogTitle, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { KeyboardPaddingBottom } from 'utils/styles.utils';

import { LoginFormFields } from 'components/@account/Authentication/types';
import { useEmailLinkFlow } from 'components/@account/useEmailLinkFlow';

interface Props {
  afterSignInUrl: string;
}

const CheckInbox = ({ afterSignInUrl }: Props) => {
  const { getValues } = useFormContext<LoginFormFields>();
  const emailAddress = getValues('emailAddress');
  const { onEmailLinkSignInOrSignup, isLoading } = useEmailLinkFlow();

  const handleResendEmail = async () => {
    await onEmailLinkSignInOrSignup({ emailAddress, afterSignInUrl });
  };

  return (
    <>
      <DialogTitle>
        <FormattedMessage id="account.email.link.send.title" />
      </DialogTitle>
      <DialogContent sx={KeyboardPaddingBottom}>
        <Typography
          variant="body2"
          sx={{
            mb: 1,
          }}
        >
          <FormattedMessage
            id="account.email.link.send.description"
            values={{
              email: emailAddress,
              b: (chunks: Array<ReactNode>) => {
                return (
                  <Typography
                    variant="body2"
                    component="span"
                    sx={{
                      fontWeight: 'bold',
                    }}
                  >
                    {chunks}
                  </Typography>
                );
              },
            }}
          />
        </Typography>
        <Typography
          variant="body1"
          component={Button}
          onClick={handleResendEmail}
          disabled={isLoading}
          sx={{
            width: 'fit-content',
          }}
        >
          <FormattedMessage id="account.resend.email.button" />
        </Typography>
      </DialogContent>
    </>
  );
};

export default CheckInbox;
